import { render, staticRenderFns } from "./sysDictionary.vue?vue&type=template&id=876978d8&"
import script from "./sysDictionary.vue?vue&type=script&lang=js&"
export * from "./sysDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('876978d8')) {
      api.createRecord('876978d8', component.options)
    } else {
      api.reload('876978d8', component.options)
    }
    module.hot.accept("./sysDictionary.vue?vue&type=template&id=876978d8&", function () {
      api.rerender('876978d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/dictionary/sysDictionary.vue"
export default component.exports